/**
 * This class implements the INavigationClient interface to gain full control of
 * how navigation happens. In order to support *.netlify.app domains for preview
 * builds, we are using a custom proxy. This proxy helps bypass the lack of wildcard
 * of support in ADB2C.
 *
 * @see https://azuread.github.io/microsoft-authentication-library-for-js/ref/interfaces/_azure_msal_browser.inavigationclient.html
 * @see https://learn.microsoft.com/en-us/azure/active-directory/develop/reply-url#restrictions-on-wildcards-in-redirect-uris
 * @see https://github.com/RollKall/ad-proxy
 *
 * @class ProxyNavigationClient
 */
class ProxyNavigationClient {
	constructor(proxyUrl) {
		this.proxyUrl = proxyUrl;
	}

	navigate = (url, options) => {
		if (options.noHistory) {
			window.location.replace(url);
		} else {
			window.location.assign(url);
		}

		return new Promise((resolve) => {
			setTimeout(() => {
				resolve(true);
			}, options.timeout);
		});
	}

	navigateInternal(url, options) {
		return this.navigate(url, options);
	}

	navigateExternal(url, options) {
		const proxyUrl = new URL(this.proxyUrl);
		proxyUrl.searchParams.append('to', url);

		return this.navigate(proxyUrl.href, options);
	}
}

export default ProxyNavigationClient;
